import React, { useState, useEffect } from 'react';
import './GenerateButton.css';

function GenerateButton({ generating, disabled, onClick, defaultTitle = '' }) {
  const [title, setTitle] = useState(defaultTitle);

  // Update title when defaultTitle changes (when sections change)
  useEffect(() => {
    setTitle(defaultTitle);
  }, [defaultTitle]);

  const handleGenerate = () => {
    onClick(title);
  };

  return (
    <div className="generate-section">
      <div className="title-input-container">
        <label htmlFor="newsletter-title" className="title-label">
          Newsletter Title
        </label>
        <input
          id="newsletter-title"
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Enter newsletter title..."
          className="title-input"
          disabled={generating}
        />
      </div>
      <button
        className={`generate-button btn-primary btn-large ${generating ? 'generating' : ''}`}
        onClick={handleGenerate}
        disabled={disabled || !title.trim()}
      >
        {generating ? 'Generating...' : 'Generate Newsletter'}
      </button>
    </div>
  );
}

export default GenerateButton;
